import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import CertificateViewContainer from './CertificateViewContainer';

function CertificateRoot(props) {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          path="/certificate/:certificateId"
          exact
          component={CertificateViewContainer}
        />
      </Switch>
    </BrowserRouter>
  );
}

export default props => <CertificateRoot {...props} />;
